
import { css } from 'lit';
export default css`
:host{
  --heading-font-family:var(--ff-body);
  --details-min-column-width:296px;

  display:block;
}

:host([layout='stacked']){
  display:flex;
}

.person-card.stacked{
  display:flex;
  gap:var(--spacing-6);
  border-top:2px solid var(--purple-medium-neutral);
  padding-top:var(--spacing-6);
}

.person-card.stacked .content{
    display:flex;
    flex-direction:column;
    gap:var(--spacing-2);
    height:100%;
  }

.person-card.stacked .image{
    max-width:100px;
  }

@media (min-width: 768px){
  .person-card.stacked{
    flex-direction:column;
    transition:all 300ms ease-out;
    padding-top:var(--spacing-8);
    padding-right:var(--spacing-6);
    padding-bottom:var(--spacing-8);
    padding-left:var(--spacing-6);
  }

    .person-card.stacked:hover{
      border-color:var(--neutral-light);
      border-radius:0px 0px 32px 0px;
      background-color:var(--neutral-light);
    }

    .person-card.stacked .image{
      max-width:100%;
    }
}

.person-card.inline{
  display:flex;
  align-items:flex-start;
  gap:var(--spacing-6);
}

.person-card.inline .content{
    display:flex;
    flex-direction:column;
    gap:var(--spacing-2);
  }

.person-card.inline .image{
    max-width:104px;
  }

.person-card.has-border-x{
  border-top:2px solid var(--purple-medium-neutral);
  border-bottom:2px solid var(--purple-medium-neutral);
  padding-top:var(--spacing-6);
  padding-bottom:var(--spacing-6);
}

.image{
  flex-shrink:0;
  border-radius:var(--spacing-2);
  overflow:hidden;
}

.image img{
    display:block;
    width:100%;
    object-fit:cover;
  }

.contact{
  margin-top:auto;
}

::slotted([slot='contact']){
  display:flex;
  align-items:center;
  gap:var(--spacing-8);
  margin-top:var(--spacing-4);
}

@media print{

::slotted([slot='contact']){
    margin-top:var(--spacing-0);
    flex-direction:column-reverse;
    align-items:start;
    gap:var(--spacing-4)
}
  }

::slotted([slot='title']){
  line-height:var(--lh-eyebrow-mobile);
  font-size:var(--fs-eyebrow-mobile);
}

@media (min-width: 992px){

::slotted([slot='title']){
    font-size:var(--fs-eyebrow);
    line-height:var(--lh-eyebrow)
}
  }

::slotted([slot='location']),
::slotted([slot='detail']){
  line-height:var(--lh-body-mobile);
  font-size:var(--fs-body-mobile);
}

@media (min-width: 992px){

::slotted([slot='location']),
::slotted([slot='detail']){
    line-height:var(--lh-body);
    font-size:var(--fs-body)
}
  }
`;